import { render, staticRenderFns } from "./Resultat.vue?vue&type=template&id=0b51b7dc"
import script from "./Resultat.vue?vue&type=script&lang=js"
export * from "./Resultat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports